module.exports = " <h2>Physical whereabouts</h2> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/crud/clerk-transaction-row/curate-steps/transactions.transactions.whereabouts.html
// module id = 2802
// module chunks = 86